import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import { FontUpgrade } from 'wix-style-react';
import { renderModel } from './util/renderModel';
import App from './contact-page/components/App';
import './styles/global.scss';

const { locale, messages } = renderModel.get();
const i18n = initI18n({ locale, messages });

ReactDOM.render(
  <Suspense fallback="...loading">
    <I18nextProvider i18n={i18n}>
      <FontUpgrade>
        <App />
      </FontUpgrade>
    </I18nextProvider>
  </Suspense>,
  document.getElementById('root'),
);
